import { useRef, useState } from "react";
import { ImagePlus, Loader2, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLang } from "@/lib/i18n";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";

export const MultiImageUpload = ({ slug, images = [], onChange, testId = "multi-image-upload" }) => {
  const { t } = useLang();
  const fileRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const upload = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setUploading(true);
    try {
      const urls = [];
      for (const file of files) {
        const fd = new FormData();
        fd.append("file", file);
        const { data } = await api.post(`/associations/${slug}/upload`, fd);
        urls.push(data.url);
      }
      onChange([...images, ...urls]);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setUploading(false);
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  return (
    <div data-testid={testId}>
      {images.length > 0 && (
        <div className="grid grid-cols-3 gap-2 mb-2">
          {images.map((img, i) => (
            <div key={`${img}-${i}`} className="relative">
              <img src={img} alt="" className="h-20 w-full object-cover rounded-md border border-border" />
              {i === 0 && (
                <span className="absolute bottom-1 left-1 text-[9px] font-mono-data uppercase bg-black/70 text-white px-1.5 py-0.5 rounded">
                  {t("main_image")}
                </span>
              )}
              <button
                type="button"
                data-testid={`${testId}-remove-${i}`}
                onClick={() => onChange(images.filter((_, x) => x !== i))}
                className="absolute top-1 right-1 h-5 w-5 rounded-full bg-black/70 text-white flex items-center justify-center hover:bg-black/90 transition-colors"
              >
                <X className="h-3 w-3" />
              </button>
            </div>
          ))}
        </div>
      )}
      <input ref={fileRef} type="file" accept="image/*" multiple className="hidden" onChange={upload} data-testid={`${testId}-file-input`} />
      <Button type="button" variant="outline" size="sm" data-testid={`${testId}-add-btn`} onClick={() => fileRef.current?.click()} disabled={uploading} className="rounded-full">
        {uploading ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <ImagePlus className="h-4 w-4 mr-2" />}
        {t("add_image")}
      </Button>
    </div>
  );
};
